import React from 'react';
import PropTypes from 'prop-types';
import { Box, NakedButton, Text } from 'roo-ui/components';
import PointsEarnDisplay from 'components/PointsEarnDisplay';
import { useTooltip } from 'lib/hooks';
import { TooltipWrapper } from './primitives';

const BusinessRewardsTooltip = ({ qbrPoints }) => {
  const { triggerProps, tooltipProps, isOpen } = useTooltip('qbr-total-button');

  return (
    <NakedButton {...triggerProps} pb={2}>
      <Text display="block" fontSize="base">
        Plus <PointsEarnDisplay {...qbrPoints} /> Points{' '}
        <Text color="greys.steel" fontSize="base" textDecoration="underline">
          for your business
        </Text>
      </Text>
      {isOpen && (
        <Box {...tooltipProps}>
          <TooltipWrapper>
            <Text>
              Travelling for business? Add your Qantas Business Rewards membership ABN number to any domestic or international Qantas Hotels
              booking and your business* will earn 1 Qantas Point per A$1 spent.
            </Text>
          </TooltipWrapper>
        </Box>
      )}
    </NakedButton>
  );
};

BusinessRewardsTooltip.propTypes = {
  qbrPoints: PropTypes.shape({ total: PropTypes.number }).isRequired,
};

export default BusinessRewardsTooltip;
